import { render, staticRenderFns } from "./CrewChangeTask.vue?vue&type=template&id=b70e19e0"
import script from "./CrewChangeTask.vue?vue&type=script&lang=js"
export * from "./CrewChangeTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports